import { Component, Vue } from 'vue-property-decorator';

/**
 * See <a href="https://www.npmjs.com/package/v-snackbars">v-snackbars</a>
 */
// @ts-ignore
import VSnackbars from 'v-snackbars';
@Component({
  components: {
    'v-snackbars': VSnackbars,
  },
})
export default class SpeVToast extends Vue {
  public items: any[] = [];

  public toast(message: string, options: { [k: string]: any }) {
    this.items.push({ ...options, message: message, header: 'test' });
  }
}
